import { render, staticRenderFns } from "./CodigoDescuentos.vue?vue&type=template&id=48519af0&scoped=true&"
import script from "./CodigoDescuentos.vue?vue&type=script&lang=js&"
export * from "./CodigoDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./CodigoDescuentos.vue?vue&type=style&index=0&id=48519af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48519af0",
  null
  
)

export default component.exports